module.exports = __webpack_public_path__ + "img/icon10.f5fe121d.png";